/* eslint-disable no-console */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import * as React from 'react';
import styled from 'styled-components';
import AddIcon from '@material-ui/icons/Add';
import { useState } from 'react';
import { queryCache, useMutation } from 'react-query';
import * as groupsApi from '../../api/groupapi';

const StyledDialog = styled(Dialog)`
  & .MuiPaper-root {
    padding: 24px;
    ${(p) => p.theme.breakpoints.down('xs')} {
      margin: 16px;
      padding: 16px;
    }
  }
`;

export const AddGroupDialog = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const [addGroup] = useMutation(groupsApi.addGroup, {
    onSuccess: () => {
      queryCache.invalidateQueries();
      onClose();
    },
  });
  const [name, setName] = useState('');
  return (
    <StyledDialog
      open={open}
      // @ts-ignore
      onClose={onClose}
      onClick={(e) => e.stopPropagation()}
    >
      <DialogTitle color="primary">Add new group</DialogTitle>
      <Divider />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} style={{ marginTop: '8px' }}>
            <TextField
              label={<Typography variant="caption">Name</Typography>}
              variant="outlined"
              onChange={(evt) => setName(evt.target.value)}
              fullWidth
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          autoFocus
          startIcon={<AddIcon />}
          onClick={() =>
            addGroup({
              name,
              selected: false,
              school: 'GEORGIA',
              students: [],
              subjects: [],
            })
          }
        >
          Add group
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};
